export enum FilterAttributeTypes {
	TEXT = 'TEXT',
	NUMBER = 'NUMBER',
	DATE = 'DATE',
	SAT = 'SATSCORE',
	DIMENSIONAL = 'DIMENSIONAL',
	MODEL = 'MODEL',
	RANGE = 'RANGE'
}
